/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var emrValidateCheckoutCounter = 200;

function emrValidateCheckout() {
  checkoutBtn = document.getElementsByClassName('Cart__Checkout')[0];
  if (checkoutBtn) {
    var cartItems = document.getElementsByClassName('CartItem');
    var hasSubscription = false;
    var hasNonsubscription = false;
    var singleBottleCount = 0;

    for (var i = 0; i < cartItems.length; i++) {
      var cartItem = cartItems[i];
      if (cartItem.hasAttribute('data-emr-subscription')) {
        hasSubscription = true;
      } else {
        hasNonsubscription = true;
      }
      if (!(cartItem.hasAttribute('data-emr-bundle') || cartItem.hasAttribute('data-emr-exempt'))) {
        singleBottleCount = singleBottleCount + parseInt(cartItem.querySelector('.QuantitySelector__CurrentQuantity').value);
      }
    }

    if (hasSubscription && hasNonsubscription) {
      checkoutBtn.classList.add('emr--disabled');
      document.getElementsByClassName('Cart__Subscription-Rules')[0].classList.remove('emr--disabled');
    }
    
    if (singleBottleCount != 0 && singleBottleCount != 3 && singleBottleCount != 6 && singleBottleCount != 12) {
      checkoutBtn.classList.add('emr--disabled');
      document.getElementsByClassName('emr--single-bottle-qty')[0].innerHTML = singleBottleCount;
      document.getElementsByClassName('Cart__Shipping-Quantities')[0].classList.remove('emr--disabled');
    }
  } else if (emrValidateCheckoutCounter > 0) {
    emrValidateCheckoutCounter = emrValidateCheckoutCounter - 1;
    window.setTimeout(emrValidateCheckout, 50);
  }
}

document.addEventListener('theme:loading:end', emrValidateCheckout);
emrValidateCheckout();
